import sha256 from 'crypto-js/sha256';

let UDID = '';
let sessionId = '';

const getInfoForIp = async () => {
  try {
    const response = await fetch('https://json.geoiplookup.io/');
    const {
      ip,
      latitude,
      longitude,
      city,
      country_name: countryName,
      region,
      success,
    } = await response.json();

    if (success) {
      return {
        ip,
        latitude,
        longitude,
        city,
        countryName,
        region,
      };
    }

    return false;
  } catch (e) {
    console.error(e);

    return false;
  }
};

const registerUser = async () => {
  const { userAgent, language } = navigator;
  const { width, height } = window.screen;

  let deviceData = {
    userAgent,
    language,
    screen: {
      width,
      height,
    },
  };

  try {
    const ipInfo = await getInfoForIp();

    if (ipInfo) {
      deviceData = { ...deviceData, ...ipInfo };
    }
  } catch (e) {
    console.error(e);
  }

  UDID = sha256(JSON.stringify(deviceData)).toString();
  deviceData.id = UDID;
  delete deviceData.ip;

  try {
    await fetch('/.netlify/functions/visitor', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(deviceData),
    });

    return UDID;
  } catch (e) {
    console.error(e);

    return false;
  }
};

const sendPageView = async (page) => {
  const date = new Date();

  if (!UDID) {
    const registerd = await registerUser();

    if (!registerd) {
      UDID = 'unregistered';
    }
  }

  const pageView = {
    date,
    page,
    UDID,
  };

  if (sessionId) {
    pageView.sessionId = sessionId;
  }

  if (document.referrer) {
    pageView.referrer = document.referrer;
  }

  try {
    const response = await fetch('/.netlify/functions/pageview', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(pageView),
    });

    const json = await response.json();

    if (json.sessionId) {
      ({ sessionId } = json);
    }
  } catch (e) {
    console.error(e);
  }
};

export default {
  sendPageView,
  registerUser,
};

export {
  sendPageView,
  registerUser,
};
